<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.document-configuration.dialog.title' | translate"
		id="inventory-kind-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div
					class="grid"
					[sklValidationSource]="viewValidation"
					[skl-focus-by]>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.name.label' | translate">
							<ins-input
								id="inventory-kind-dialog-document-name"
								[(ngModel)]="viewModel.documentName"
								[placeholder]="'scenes.configuration.shared.document-configuration.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					@if (viewModel.isDefaultCalculationMethodVisible) {
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.document-configuration.dialog.form.default-count-from.label' | translate">
								<ins-select
									id="inventory-kind-dialog-calculation-method"
									display-text="label"
									[converter]="viewModel.calculationMethodsConverter"
									[(ngModel)]="viewModel.bo.model.defaultCalculationMethod"
									[sklValidate]="getValidationKey('defaultCalculationMethod')">
									@for (item of viewModel.calculationMethods; track item) {
										<ins-option
											[value]="item">
											{{ item.label }}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
					}
					@if (viewModel.isTransactionLocationVisible()) {
						<div class="col-1 align--medium-top">
							<ins-checkbox
								id="inventory-kind-dialog-use-company-transaction-location"
								[(ngModel)]="viewModel.useCompanyTransactionLocation.value"
								[label]="'scenes.configuration.shared.document-configuration.dialog.form.transaction-location-from-company.label' | translate"
								[sklValidate]="getValidationKey('useCompanyTransactionLocation')">
							</ins-checkbox>
						</div>
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.document-configuration.dialog.form.transaction-location.label' | translate">
								<ins-input
									id="inventory-kind-dialog-custom-transaction-location"
									[(ngModel)]="viewModel.bo.model.customTransactionLocation"
									[placeholder]="'scenes.configuration.shared.document-configuration.dialog.form.transaction-location.placeholder' | translate"
									[sklValidate]="getValidationKey('customTransactionLocation')">
								</ins-input>
							</ins-form-field>
						</div>
					}
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="inventory-kind-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.configuration.shared.base.dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			id="inventory-kind-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{'scenes.configuration.shared.base.dialog.buttons.save' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>